import { render, staticRenderFns } from "./ContactEditPage.vue?vue&type=template&id=d61f80ca&"
import script from "./ContactEditPage.vue?vue&type=script&lang=ts&"
export * from "./ContactEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61f80ca')) {
      api.createRecord('d61f80ca', component.options)
    } else {
      api.reload('d61f80ca', component.options)
    }
    module.hot.accept("./ContactEditPage.vue?vue&type=template&id=d61f80ca&", function () {
      api.rerender('d61f80ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contact-data/ContactEditPage.vue"
export default component.exports